export const FETCH_COMPETITIONS_LIST = 'FETCH_COMPETITIONS_LIST';
export const SET_COMPETITIONS_LIST = 'SET_COMPETITIONS_LIST';
export const EDIT_COMPETITIONS_LIST = 'EDIT_COMPETITIONS_LIST';
export const DELETE_COMPETITIONS_LIST = 'DELETE_COMPETITIONS_LIST';

export const POST_COMPETITION = 'POST_COMPETITION';
export const PUT_COMPETITION = 'PUT_COMPETITION';
